import React from "react";
import { Box, UnstyledButton, Group, Text } from "@mantine/core";
import { IconX } from "@tabler/icons";

interface FilterFooterProps {
  onClickClear?: () => void; // Function to call when the clear filter button is clicked
  ApplyButton?: React.ReactNode; // Optional React node for the apply button
  editMode?: boolean;
  /**
   * Wording for the clear action. Defaults to the filter phrasing; the release
   * assignment picker reuses this footer to clear a *selection*, not a filter.
   */
  clearLabel?: string;
}


const FilterFooter: React.FC<FilterFooterProps> = ({
  onClickClear,
  ApplyButton,
  editMode,
  clearLabel = "Clear filters",
}) => {
  return (
    <Box
      sx={{
        backgroundColor: "#F8F9FA",
        borderRadius: "0 0 8px 8px",
        height: 48,
        alignContent: "center",
      }}
      pl="md"
      pr={8}
      py={8}
    >
      <Group position="apart">
        {onClickClear && !editMode ? (
          <UnstyledButton onClick={onClickClear}>
            <Group
              spacing={5}
              sx={{
                color: "#5C5CEB",
              }}
            >
              <IconX size={13} />
              <Text size={13}>{clearLabel}</Text>
            </Group>
          </UnstyledButton>
        ) : (
          <Box></Box>
        )}
        {ApplyButton}
      </Group>
      
    </Box>
  );
};

export default FilterFooter;
